"use client"

import { BlogCategory, BlogEntryThin } from "@/api/generated/BMWInterfaces"
import { styled } from "@mui/material"
import BlogCard from "./BlogCard"

const StyledGrid = styled("div")`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 24px;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up("md")} {
    grid-template-columns: repeat(3, minmax(calc(100% / 3 - 10px), auto));
    & > *:nth-child(3n + 2) {
      margin: 0 auto;
    }

    & > *:nth-child(3n + 1) {
      margin: unset;
      margin-left: auto;
    }

    & > *:nth-child(3n) {
      margin: unset;
      margin-right: auto;
    }
    column-gap: 5px;
    width: 100%;
  }
  ${({ theme }) => theme.breakpoints.up("lg")} {
    grid-template-columns: repeat(3, minmax(328px, auto));
  }

  ${({ theme }) => theme.breakpoints.up("xl")} {
    max-width: 1080px;
    margin: 0 auto;
    gap: 48px;
  }
`

const BlogsGrid = ({
  blogs,
  categories,
  pageSize,
}: {
  blogs: BlogEntryThin[]
  categories: BlogCategory[]
  pageSize: number
}): React.ReactElement => {
  const visibleBlogs = blogs?.slice(0, pageSize)
  return (
    <StyledGrid>
      {visibleBlogs?.map((blog, index) => {
        const category = categories.find((cat) => cat.id === blog.categoryId)?.name
        return <BlogCard key={`${blog.id}-${index}`} blog={blog} category={category} />
      })}
    </StyledGrid>
  )
}

export default BlogsGrid
